<div class="notebook-secret-modal">
  <div class="secret-modal-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mode-dialog-header>
      <h1 heading>Update secret</h1>
    </mode-dialog-header>
  </div>
  <div class="content-container">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="form-input">
        <label for="secretKey">Display name</label>
        <input id="secretKey" type="text" formControlName="secretKey" data-test="secretKey" autocomplete="off" />
      </div>
      <div class="form-input">
        <label for="secretValue">New Secret value</label>
        <input
          id="secretValue"
          [type]="showPassword ? 'text' : 'password'"
          data-test="secretValue"
          formControlName="secretValue"
          #secretValueInput
          [ngClass]="{ error: secretValue?.invalid && (secretValue?.dirty || secretValue?.touched) }"
          autocomplete="off"
        />
        <div class="text-error" *ngIf="secretValue?.invalid && (secretValue?.dirty || secretValue?.touched)">
          <div *ngIf="secretValue.errors.required">Secret value can’t be blank</div>
          <div *ngIf="secretValue.errors.maxlength">Secret value can’t be more than 4096 characters long</div>
        </div>
      </div>
      <div class="form-input checkbox">
        <span class="checkbox-icon">
          <input
            id="showValue"
            data-test="showValue"
            type="checkbox"
            (change)="togglePasswordVisibility()"
            formControlName="showValue"
            class="checkbox"
          />
          <label for="showValue" class="inline-icon icon-editor-checkbox-light-unchecked">Show value</label>
        </span>
      </div>
      <div class="action-buttons">
        <div class="right-actions">
          <capra-button
            type="button"
            data-test="secret-modal-cancel-button"
            text="Cancel"
            variant="secondary"
            color="neutral"
            (clicked)="close()"
          ></capra-button>
          <capra-button
            type="button"
            data-test="secret-modal-edit-button"
            text="Save"
            color="default"
            [disabled]="!form.valid"
            (clicked)="onSubmit()"
          ></capra-button>
        </div>
      </div>
    </form>
  </div>
</div>
